<!-- add ql-editor class to apply quill styles to paragraphs -->
<!-- <div class="ql-editor"> -->
  <div [innerHTML]="data.text"></div>
<!-- </div> -->
